/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyDimensionTriggerRequest {
    getFixupPrototypeFunction() { return CostAnomalyDimensionTriggerRequest.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyDimensionTriggerRequest>): CostAnomalyDimensionTriggerRequest {
        let obj = Object.assign(new CostAnomalyDimensionTriggerRequest(), model);
        CostAnomalyDimensionTriggerRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyDimensionTriggerRequest>): CostAnomalyDimensionTriggerRequest {
        if (!model) return null;
        return CostAnomalyDimensionTriggerRequest.newInstance(<CostAnomalyDimensionTriggerRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyDimensionTriggerRequest) {
        if (!obj) return;

        models.CostAnomalyDimensionTriggerRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyDimensionTriggerRequest): boolean {
        Object.setPrototypeOf(obj, CostAnomalyDimensionTriggerRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Dimension ID
     */
    dimension_id: string;

    grouping_rule_ids: Array<string>;

}
